import { ReactElement } from 'react';
import { HomePage } from './home/components/HomePage';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import {
  KINNECT_EMAIL_CONFIRMATION_PAGE_PATH,
  KINNECT_PAGE_PATH,
  KINNECT_PASSWORD_RESET_PAGE_PATH,
  ROOT,
} from './routes/paths';
import KinnectConfirmationPage from './projects/kinnect/components/KinnectConfirmationPage';
import { ThemeProvider } from '@mui/material';
import theme from './theme';
import KinnectPasswordResetPage from './projects/kinnect/components/KinnectPasswordResetPage';
import KinnectNotFoundPage from './projects/kinnect/components/KinnectNotFoundPage';
import GlobalNotFoundPage from './home/components/GlobalNotFoundPage';

function App(): ReactElement {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route path={ROOT} element={<HomePage />} />
          <Route
            path={KINNECT_EMAIL_CONFIRMATION_PAGE_PATH}
            element={<KinnectConfirmationPage />}
          />
          <Route
            path={KINNECT_PASSWORD_RESET_PAGE_PATH}
            element={<KinnectPasswordResetPage />}
          />
          <Route
            path={`${KINNECT_PAGE_PATH}/*`}
            element={<KinnectNotFoundPage />}
          />
          <Route path={`*`} element={<GlobalNotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
